module.exports = __webpack_public_path__ + "img/KR.db5b1d4e.svg";